import React from 'react';
import { createComponent, Container, Flex, Title, Slot, For, IntrinsicProps, If } from 'react-commons';
import PerDevice from '../PerDevice';

import style from './index.module.scss';
import DailyGamesModel from '@/lib/drupal/models/DailyGames';
import useSWR from 'swr';
import Link from 'next/link';
import { CaptureClickEvent } from '@/lib/util/captureClickEvent';

interface ModernAppFooterProps extends IntrinsicProps {
  useAdColumn?: boolean
  hideLinks?: boolean
}

export default createComponent<ModernAppFooterProps>('ModernAppFooter', { style }, function ModernAppFooter ({ className }, props) {
  const { data: games, isLoading: isLoadingGames } = useSWR([ 12, 0 ], ([ limit, offset ]) => DailyGamesModel.getFeaturedGames(limit, offset));
  
  return (
    <footer className={className + (props.useAdColumn ? ' --useAdColumn' : '')}>
      <Container>
        <PerDevice>

          {/* Mobile */}
          <Slot name='mobile'>
            {
              If(props.hideLinks, () => (
                <Flex gap2>
                  <div 
                    className='ModernAppFooter__About'
                  >
                    <img 
                      className='ModernAppFooter__Logo' 
                      src='/images/SW25.svg' 
                      alt='Shockwave Logo'
                      aria-hidden 
                    />
                    <p>Copyright © {new Date().getFullYear()} Shockwave Games, Inc; all rights reserved.</p>
                  </div>
                </Flex>
              )).EndIf()
            }
          </Slot>

          {/* Desktop */}
          <Slot name='desktop'>
            <Flex gap2>
              <div 
                className='ModernAppFooter__About'
                style={{
                  maxWidth: !props.hideLinks ? '365px' : 'none',
                }}
              >
                <img 
                  className='ModernAppFooter__Logo' 
                  src='/images/SW25.svg' 
                  alt='Shockwave Logo'
                  aria-hidden 
                />
                {
                  If(props.hideLinks, () => (
                    <p>Copyright © {new Date().getFullYear()} Shockwave Games, Inc; all rights reserved.</p>
                  )).Else(() => (
                    <p>
                      Shockwave.com, launched in 1998 by Macromedia, has a rich history as a pioneer in online gaming and interactive media. Initially showcasing Shockwave and Flash player capabilities, it quickly became a leading platform for games, collaborating with iconic brands like Disney and Pixar. Over the decades, Shockwave evolved through strategic mergers, partnerships, and acquisitions, including its exclusive partnership with The Article 19 Group, which has delivered top daily games like the beloved Daily Jigsaw. Now, under the guidance of new leadership and driven by a renewed vision, Shockwave blends nostalgia with innovation, offering a curated mix of classic and modern games. With a strong focus on daily games and a commitment to casual gaming excellence.
                    </p>
                  )).EndIf()
                }
              </div>
              {
                If(!props.hideLinks, () => (
                  <>
                    <div className='ModernAppFooter__GameLinksContainer'>
                      <Title h5 size6>Daily Games</Title>
                      <ul className='ModernAppFooter__GameLinks'>
                        {
                          For(games || [], (item, i) => (
                            <li key={i}>
                              <Link href={item.href}>
                                <a className='Flex Flex--directionRow Flex--alignCenter'>
                                  <img 
                                    src={item.mobileIcon} 
                                    alt={item.title + ' icon'}
                                  />
                                  <span>{item.title}</span>
                                </a>
                              </Link>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                    <div>
                      <Title h5 size6>Shockwave</Title>
                      <ul>
                        <li>
                          <CaptureClickEvent
                            action='upsell'
                            location='modern_app_footer'
                            href='/unlimited'
                            className='upsell_footer'
                            properties={() => ({
                              tag_name: 'upsell_footer',
                            })}
                          >
                            <Link href='/unlimited'><a className='upsell_footer'>Subscribe</a></Link>
                          </CaptureClickEvent>
                        </li>
                        <li>
                          <Link href='/download/all-games'>Downloadable Games</Link>
                        </li>
                        <li>
                          <Link href='/online/all-games'>Online Games</Link>
                        </li>
                        <li>
                          <Link href='/help'>FAQ</Link>
                        </li>
                        <li>
                          <Link href='/about'>About</Link>
                        </li>
                        <li>
                          <Link href='/about/terms'>Terms of Use</Link>
                        </li>
                        <li>
                          <Link href='/about/privacyPolicy'>Privacy Policy</Link>
                        </li>
                      </ul>
                    </div>
                  </>
                )).EndIf()
              }
            </Flex>
          </Slot>
        
        </PerDevice>
      </Container>
    </footer>
  );
});
